<template>
  <div class="home">
    <div class="container">
      <div class="columns is-centered">
        <div class="column">
          <ValidationObserver v-slot="{ errors }" tag="div">
            <input-form
              ref="form"
              :errors="errors"
              name="SHARCFileUpload"
              @submit.prevent="onFileUpload"
            >
              <div class="content">
                <div>
                    <h1>Upload {{fileType}} files</h1>

                    <callout type="warning">
                      <b>Note: File size must be 100MB or less</b>
                    </callout>
                  <br />
                  <!--<input multiple 
                  type="file" @change="addFiles()" />-->
                  <file-upload
                        ref="upload"
                        v-model="awsFiles"
                        :input-id="`file-awsFiles`"
                        extensions="gif,jpg,jpeg,png,webp,pdf,xlsx,xls"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        :multiple="true"
                        label="File"
                        @input-filter="inputFilter"
                        >
                        <button class="button is-primary" style="margin-bottom: 1%;">
                          <i class="fa fa-plus" />
                          &nbsp; Select Files to Upload
                        </button>
                  </file-upload>
                  <li v-for="file in awsFiles" :key="file.id">
                          <span>{{ file.name }} - </span>
                          <span
                            v-if="file.error"
                            class="is-love-park-red"
                          >
                    Something went wrong - {{ file.errorMessage }}
                  </span>

                  <span
                    v-else-if="file.success"
                    class="is-phanatic-green"
                  >
                    Upload Successful.
                  </span>
                  <span
                    v-else-if="file.uploading"
                    class="is-flyers-orange"
                  >
                    Uploading Document...</span>
                  </li>
                  <br />
                  <br />
                  <div>
                    <div class="column is-2 is-offset-10">
                      <button
                        type="button"
                        :disabled="
                          SubmitStatus.Value === 'PENDING' ||
                            SubmitStatus.Value === 'OK'
                        "
                        class="button is-primary"
                        @click="onFileUpload"
                      >
                        Upload
                      </button>
                      <div class="column">
                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
                      Submitting...
                    </div>
                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.OK">
                      OK
                    </div>
                    <div v-if="SubmitStatus.Value === SubmitStatus.Options.ERROR">
                      Error
                    </div>
                  </div>
                    </div>
                  </div>
                </div>
              </div>
            </input-form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//https://docs.aws.amazon.com/AmazonS3/latest/userguide/upload-objects.html
//https://stackoverflow.com/questions/74522328/uploading-images-to-aws-s3-bucket-specifying-file-path-for-randomly-generated
// import { PutObjectCommand, S3Client } from "@aws-sdk/client-s3";
import FileUpload from "vue-upload-component";
import { dataObjectToXml } from "@/utilities/functions.js";
import buildFileSubmissionDataObject from "@/utilities/file-submission-object.js";
import axios from "axios";
import options from "@/utilities/options";

export default {
  name: 'HomePage',
  components: { FileUpload },
  mixins: [options],
  props: {
    recordID: { type: String, default: null },
    project: { type: String, default: null },
    fileType: { type: String, default: null },
  },
  data() {
    return {
      awsFiles: [],
      fileURL: null,
      fileName: null,
      submitStatus: null,
      newResponse: null,
    };
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    async uploadToS3(presignedUrl, file) {
      
  
      const response = await axios(presignedUrl, {
        method: 'PUT',
        data: file
      });

      return response;
      
    },
    async onFileUpload() {
      for(var i = 0; i < this.awsFiles.length; i++){
        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
        this.awsFiles[i].uploading = true;
        this.awsFiles[i].error = false;
        this.awsFiles[i].errorMessage = "";
        

        const file = this.awsFiles[i].file
        const fileName = `${this.project}/${this.awsFiles[i].name}`;


        let formData = { 'key': fileName };

        try {

          if(file.size/1000000 > 100){
      
             throw "File size is over 100MB"
           }
           var presignedURL;

          await axios.post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/dpd-SHARC-S3-Uploads", formData
          ).then(response => {

            presignedURL = response.data;
  
        }).catch(err => {
          

            this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
            this.awsFiles[i].uploading = false;
            this.awsFiles[i].error = true;
            console.log(err.response);
            this.awsFiles[i].errorMessage = err.response.data.message;
            throw err;

          });

          var newResponse = await this.uploadToS3(presignedURL, file);

          
          console.log(newResponse);
          if(newResponse.status != 200){
          throw "File Failed to Upload. Please try again."
        } 

        var URL = encodeURI(`https://d36c7re22txn7e.cloudfront.net/${this.project}/${this.awsFiles[i].name}`);

          this.fileURL = `<a target = '_blank' href='${URL}'>${this.awsFiles[i].name}</a>`;
          this.fileName = this.awsFiles[i].name;
          var vData = this;
          const isInputValid = await vData.$refs.form.$parent.validate();
          if (isInputValid) {
            const dataObject = buildFileSubmissionDataObject(vData);
            const xmlDataObject = dataObjectToXml(dataObject);
            const requestObject = {
              table: "btphg6ez4",
              action: "API_AddRecord",
              data: xmlDataObject
            };
            //QUickBase
           await axios
              .post(
                "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/SHARC-Quickbase-Request-Proxy",
                requestObject
              )
              .then(response => {
                console.log(response);
                //this.awsFiles[i].uploading = false;
                //this.awsFiles[i].success = true;
                this.awsFiles[i].uploading = false;
                this.awsFiles[i].success = true;
              }).catch(() => {
                vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
                // this.awsFiles[i].error = true;
                // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
              })
          } else {
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            // this.awsFiles[i].error = true;
            // this.awsFiles[i].errorMessage = "An error occurred. Please try again.";
          }
        }
        catch (err) {
          this.SubmitStatus.Value = this.SubmitStatus.Options.ERROR;
          this.awsFiles[i].uploading = false;
          this.awsFiles[i].error = true;
          console.log(err);
          this.awsFiles[i].errorMessage = err;
        }

          }
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
          vData.$router.push({
                  name: "SuccessPage",
                });
    },
        
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.is-flyers-orange {
  color: hsl(35, 100%, 49%);
}
.is-phanatic-green {
  color: hsl(121.6, 38.6%, 37.1%);
}
.is-love-park-red {
  color: hsl(14.1, 100%, 40%);
}
</style>
